<template>
  <div>
    <div @click="open">
      <el-input v-model="input" disabled>
        <el-button slot="append" icon="el-icon-plus"></el-button>
      </el-input>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="language('promotionRules.addProduct')"
      :visible.sync="selGoodsDialog"
      width="90%"
      append-to-body
    >
      <template v-if="selGoodsDialog">
        <cc-search
          :config="searchConfig"
          @doSearch="doSearch"
          size="medium"
        ></cc-search>
        <cc-table
          :loadData="true"
          :config="table"
          :params="params"
          :refeshParams="refeshTable"
          :emptyText="language('productDetails.emptyText')"
          :showIndex="false"
        ></cc-table>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      required: false,
    },
  },
  model: {
    prop: "value",
    event: "click",
  },
  data() {
    return {
      selGoodsDialog: false,
      searchConfig: [
        {
          title: "Product Name（Chi.）",
          fieldName: "name",
          style: "text",
          displayName: "",
        },
        {
          title: "SKU ID（Barcode）",
          fieldName: "barcode",
          style: "text",
          displayName: "",
        },
        {
          title: "Model ID",
          fieldName: "mchProductId",
          style: "text",
          displayName: "",
        },
        {
          title: "Brand (Chi)",
          fieldName: "brand",
          style: "text",
          displayName: "",
        },
      ],
      params: {},
      refeshTable: -1,
      table: {
        api: "admin/merchant/product/query?auditStatus=1&statuses=1,2&createMb1Product=1&isDiscount=0",
        showPager: true,
        // selection: true,
        // selectionNoSubmit: true,
        // selectingResult: true,
        // indexFixed: "left",
        columns: [
          {
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            minWidth: 110,
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            prop: "auditStatus",
            lable: "Status",
            type: "tag",
            minWidth: 120,

            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "type",
            minWidth: 220,
            type: "tag",
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "isDiscount",
            lable: this.language("scrapProducts.scrapProducts"),
            minWidth: 100,
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: "是",
              },
              0: {
                tagType: "info",
                text: "否",
              },
            },
          },
          {
            prop: "mchProductId",
            lable: "Model ID",
            minWidth: 150,
          },
          {
            minWidth: 150,
            prop: "barcode",
            lable: "SKU ID（Barcode）",
          },
          {
            prop: "productNum",
            lable: "Article Master",
            minWidth: 150,
          },
          {
            minWidth: 180,
            prop: "name",
            lable: "Product Name（Chi.）",
          },
          {
            minWidth: 120,
            prop: "categories",
            lable: "Category（System）",
          },
          {
            minWidth: 120,
            prop: "brand",
            lable: "Brand",
          },
          {
            prop: "listPrice",
            lable: "OriginalPrice",
            minWidth: 100,

            render: (rows) => {
              return this.$utils.toFixedDigit(rows.listPrice, 2);
            },
          },
          // {
          //   prop: "updateAdminId",
          //   lable: "Update By",
          // },
          // {
          //   prop: "updateTime",
          //   lable: "Last Update",
          // },
          // {
          //   prop: "createTime",
          //   lable: "Create Date",
          // },
        ],
        buttons: [
          {
            name: this.language("scrapProducts.selectGoods"),
            click: (row) => {
              this.input = row.name;
              this.selGoodsDialog = false;
              this.$emit("click", row.productNum);
            },
          },
          {},
        ],
      },
      input: "",
      shopData: "",
    };
  },
  methods: {
    doSearch(e) {
      this.params = {
        ...e,
        shopNum: this.shopData.shopNum,
        mchShopNum: this.shopData.shopNum,
      };
    },
    open() {
      this.params = {
        shopNum: this.shopData.shopNum,
        mchShopNum: this.shopData.shopNum,
      };
      this.selGoodsDialog = true;
    },
  },
  mounted() {
    this.shopData = this.$shopData;
  },
};
</script>